"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _Position = _interopRequireDefault(require("./Position"));

var _PointLocation = _interopRequireDefault(require("../algorithm/PointLocation"));

var _TopologyException = _interopRequireDefault(require("../geom/TopologyException"));

var _Orientation = _interopRequireDefault(require("../algorithm/Orientation"));

var _Label = _interopRequireDefault(require("./Label"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EdgeRing =
/*#__PURE__*/
function () {
  function EdgeRing() {
    _classCallCheck(this, EdgeRing);

    EdgeRing.constructor_.apply(this, arguments);
  }

  _createClass(EdgeRing, [{
    key: "computeRing",
    value: function computeRing() {
      if (this._ring !== null) return null;
      var coord = new Array(this._pts.size()).fill(null);

      for (var i = 0; i < this._pts.size(); i++) {
        coord[i] = this._pts.get(i);
      }

      this._ring = this._geometryFactory.createLinearRing(coord);
      this._isHole = _Orientation.default.isCCW(this._ring.getCoordinates());
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._label.getGeometryCount() === 1;
    }
  }, {
    key: "computePoints",
    value: function computePoints(start) {
      this._startDe = start;
      var de = start;
      var isFirstEdge = true;

      do {
        if (de === null) throw new _TopologyException.default("Found null DirectedEdge");
        if (de.getEdgeRing() === this) throw new _TopologyException.default("Directed Edge visited twice during ring-building at " + de.getCoordinate());

        this._edges.add(de);

        var label = de.getLabel();

        _Assert.default.isTrue(label.isArea());

        this.mergeLabel(label);
        this.addPoints(de.getEdge(), de.isForward(), isFirstEdge);
        isFirstEdge = false;
        this.setEdgeRing(de, this);
        de = this.getNext(de);
      } while (de !== this._startDe);
    }
  }, {
    key: "getLinearRing",
    value: function getLinearRing() {
      return this._ring;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this._pts.get(i);
    }
  }, {
    key: "computeMaxNodeDegree",
    value: function computeMaxNodeDegree() {
      this._maxNodeDegree = 0;
      var de = this._startDe;

      do {
        var node = de.getNode();
        var degree = node.getEdges().getOutgoingDegree(this);
        if (degree > this._maxNodeDegree) this._maxNodeDegree = degree;
        de = this.getNext(de);
      } while (de !== this._startDe);

      this._maxNodeDegree *= 2;
    }
  }, {
    key: "addPoints",
    value: function addPoints(edge, isForward, isFirstEdge) {
      var edgePts = edge.getCoordinates();

      if (isForward) {
        var startIndex = 1;
        if (isFirstEdge) startIndex = 0;

        for (var i = startIndex; i < edgePts.length; i++) {
          this._pts.add(edgePts[i]);
        }
      } else {
        var startIndex = edgePts.length - 2;
        if (isFirstEdge) startIndex = edgePts.length - 1;

        for (var i = startIndex; i >= 0; i--) {
          this._pts.add(edgePts[i]);
        }
      }
    }
  }, {
    key: "isHole",
    value: function isHole() {
      return this._isHole;
    }
  }, {
    key: "setInResult",
    value: function setInResult() {
      var de = this._startDe;

      do {
        de.getEdge().setInResult(true);
        de = de.getNext();
      } while (de !== this._startDe);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(p) {
      var shell = this.getLinearRing();
      var env = shell.getEnvelopeInternal();
      if (!env.contains(p)) return false;
      if (!_PointLocation.default.isInRing(p, shell.getCoordinates())) return false;

      for (var i = this._holes.iterator(); i.hasNext();) {
        var hole = i.next();
        if (hole.containsPoint(p)) return false;
      }

      return true;
    }
  }, {
    key: "addHole",
    value: function addHole(ring) {
      this._holes.add(ring);
    }
  }, {
    key: "isShell",
    value: function isShell() {
      return this._shell === null;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "getMaxNodeDegree",
    value: function getMaxNodeDegree() {
      if (this._maxNodeDegree < 0) this.computeMaxNodeDegree();
      return this._maxNodeDegree;
    }
  }, {
    key: "getShell",
    value: function getShell() {
      return this._shell;
    }
  }, {
    key: "mergeLabel",
    value: function mergeLabel() {
      if (arguments.length === 1) {
        var deLabel = arguments[0];
        this.mergeLabel(deLabel, 0);
        this.mergeLabel(deLabel, 1);
      } else if (arguments.length === 2) {
        var _deLabel = arguments[0],
            geomIndex = arguments[1];

        var loc = _deLabel.getLocation(geomIndex, _Position.default.RIGHT);

        if (loc === _Location.default.NONE) return null;

        if (this._label.getLocation(geomIndex) === _Location.default.NONE) {
          this._label.setLocation(geomIndex, loc);

          return null;
        }
      }
    }
  }, {
    key: "setShell",
    value: function setShell(shell) {
      this._shell = shell;
      if (shell !== null) shell.addHole(this);
    }
  }, {
    key: "toPolygon",
    value: function toPolygon(geometryFactory) {
      var holeLR = new Array(this._holes.size()).fill(null);

      for (var i = 0; i < this._holes.size(); i++) {
        holeLR[i] = this._holes.get(i).getLinearRing();
      }

      var poly = geometryFactory.createPolygon(this.getLinearRing(), holeLR);
      return poly;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeRing;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EdgeRing;
}();

exports.default = EdgeRing;

EdgeRing.constructor_ = function () {
  this._startDe = null;
  this._maxNodeDegree = -1;
  this._edges = new _ArrayList.default();
  this._pts = new _ArrayList.default();
  this._label = new _Label.default(_Location.default.NONE);
  this._ring = null;
  this._isHole = null;
  this._shell = null;
  this._holes = new _ArrayList.default();
  this._geometryFactory = null;

  if (arguments.length === 0) {} else if (arguments.length === 2) {
    var start = arguments[0],
        geometryFactory = arguments[1];
    this._geometryFactory = geometryFactory;
    this.computePoints(start);
    this.computeRing();
  }
};